export default {"src":"/_next/static/media/0x17fc002b466eec40dae837fc4be5c67993ddbd6f.668df216.svg","height":284,"width":284,"blurWidth":0,"blurHeight":0};